import { formatDateWithFormatter } from '@/utils/function'
import { Typogaphy } from 'vnetwork-ui'

interface CellDateProps {
    date?: string
    scope?: string
}

const CellDate: React.FC<CellDateProps> = ({
    date = '',
    scope = 'DD/MM/YYYY',
}) => {
    if (!date) return null
    return (
        <div className="flex w-full h-full items-center justify-end">
            <Typogaphy className="" size="small">
                {formatDateWithFormatter(date, scope)}
            </Typogaphy>
        </div>
    )
}

export default CellDate
